<template>
  <v-footer height="auto" class="px-6 app--footer footer-class">
    <v-container fluid class="py-0">
      <v-divider class="mt-1"></v-divider>
      <v-row>
        <v-col class="pb-0" cols="12" sm="10">
          <p class="address mt-1 mb-1">
            © Valstybės įmonė Registrų centras, 2022
          </p>
        </v-col>
        <v-col class="pb-0" cols="12" sm="2">
          <div class="version text-end mt-1" v-if="showVersion">
            {{ version }}
          </div>
        </v-col>
      </v-row>
      <v-spacer />
    </v-container>
  </v-footer>
</template>
<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      showVersion: false,
      back_build: null,
    }
  },

  computed: {
    appVersion() {
      return process.env.VUE_APP_PACKAGE_VERSION ?? '0.0.0'
    },
    frontVersion() {
      return process.env.VUE_APP_FRONT_BUILD ?? '0'
    },
    backVersion() {
      return this.back_build ?? '0'
    },
    version() {
      return `v${this.appVersion} (${this.frontVersion}.${this.backVersion})`
    },
  },
  created() {
    this.getBuild()
  },

  methods: {
    getBuild() {
      this.$axios
        .get('version')
        .then((res) => {
          this.back_build = res.data.version
          this.showVersion = true
        })
        .catch((err) => {
          //
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/color.scss';
.version {
  color: $secondary;
  font-size: 14px;
  font-weight: 400;
}
</style>
